export interface ITogglePressVisibility {
    data: {
        visible: number;
        press_media_id: string;
    };
}
